var agreement = (function () {
    return {
        init: function () {
            $(document).ready(function () {
                $(".privacy_policy").off("click").click(function () {
                    $.fancybox.open({
                        src: '#privacy_policy_modal',
                        type: 'inline',
                    });
                });
                $(".terms_of_use").off("click").click(function () {
                    $.fancybox.open({
                        src: '#terms_of_use_modal',
                        type: 'inline',
                    });
                });
                $(".protection_of_personal_data").off("click").click(function () {
                    $.fancybox.open({
                        src: '#protection_of_personal_data_modal',
                        type: 'inline',
                    });
                });
                $(".demo_contract").off("click").click(function () {
                    $.fancybox.open({
                        src: '#demo_contract_modal',
                        type: 'inline',
                    });
                });
            });
        }
    };
})(agreement || {});